module.exports = __webpack_public_path__ + "static/media/tot_cpt-grey.c525f475.svg";